import {RadioButton} from '@priority-software/priority-style-react';
import React from 'react';
import texts from '../../../../../_legacy/Filters/texts';
import {ISearchCondition} from '../../../types/filters';
import {createDataTestId} from '../../../../../utils/dataTestId';

interface Props {
    filter: ISearchCondition;
    onChange: (value: string) => void;
}

const options = [
    {label: texts.yes, value: 'Y'},
    {label: texts.no, value: 'N'}
];

const BoolControl = ({filter, onChange}: Props) => (
    <RadioButton
        selected={filter?.values?.[0]}
        onChange={onChange}
        options={options}
        {...createDataTestId('radio-buttons-filter-box', true)}
    />
);

export default BoolControl;
